export default {
  BASE_URL: 'https://api.ppv2.affixe-logiciel.fr/api/',
  AUTHORITY_URL: 'https://id.ppv2.affixe-logiciel.fr/',
};



// WEBPACK FOOTER //
// ./src/api/config/config.staging.js